import React, { useEffect, useState } from "react";
import Space from "../ui/Space";
import Label from "../ui/Label";
import Input from "../ui/Input";
import Divider from "../ui/Divider";
import Status from "../ui/Status";
import { InfoIcon } from "../utils/Icons";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";
import { ROUTES } from "../utils/Routes";
import Menu from "../ui/Menu";
import Checkbox from "../ui/Checkbox";
import { areAll, kbdEvent, setAll } from "../utils/Utils";
import Button from "../ui/Button";
import Float from "../ui/Float";
import TextButton from "../ui/TextButton";

export default function HistoryFilters(props) {

    const { callback = () => { }, route = "", sort = "complete", filters = {} } = props;


    const formatLabel = (key) => {
        switch (key) {
            case 'a_r':
                return 'A/R';
            default:
                return key
                    .split('_')
                    .map(part => part.charAt(0).toUpperCase() + part.slice(1))
                    .join(' ');
        }
    };

    const getItem = (key) => ({
        text: (
            <Space size={10}>
                <Checkbox value={f[key]} />
                {formatLabel(key)}
            </Space>
        ),
        sort: key,
        key: KBD[key.charAt(0).toUpperCase()],
        action: () => callback({ ...setAll(f, false), [key]: true }),
    });


    const fields = ["adjustment", "held", "orders", "prepay", "quotes", "returns", "sales", "transfers"];
    const [f, setF] = useState({ ...filters });


    const menu = [
        {
            text: (
                <Space size={10}>
                    <Checkbox value={areAll(f)} />
                    Complete
                </Space>
            ),
            sort: "complete",
            key: KBD.C,
            action: () => callback({ ...setAll(f, true) }),
        },
        ...Object.keys(filters).map(getItem),
    ];

    const [selected, setSelected] = useState(sort);

    useEffect(() => {

        const actions = [
            { key: KBD.ESCAPE, action: (e) => { callback(false) } },
            { key: KBD.ENTER, action: (e) => { handleCallback(selected) } },
            { key: KBD.PAGE_DOWN, action: (e) => { callback({ ...f }) } },
        ];

        const cleanup = listen(route, actions.concat(menu));
        return cleanup;
    }, [selected, f]);


    const handleCallback = (e) => {
        setSelected(e);
        if (e === "complete") {
            if (areAll(f, true)) {
                // set to none
                let _all_removed = setAll(f, false);
                setF({ ..._all_removed });
                return;
            } else {
                let _all_added = setAll(f, true);
                setF({ ..._all_added });
                return;
            }
        }
        setF({ ...f, [e]: !f[e] })
    }

    return (
        <div style={{ "width": "250px" }}>
            <div className="shim" /><div className="shim" />
            <Menu callback={(e) => handleCallback(e.sort)} bordered keyName="sort" setSelected={setSelected} selected={selected} menu={menu} route={route} />
            <div className="shim" /><div className="shim" />
            <Float>
                <div></div>
                <Space>
                    <Button kbd={KBD.ESCAPE} onClick={() => callback(false)}>Cancel</Button>
                    <Button kbd={KBD.PAGE_DOWN} onClick={() => kbdEvent(KBD.PAGE_DOWN)} type="secondary">Apply</Button>
                </Space>
            </Float>
        </div>
    )
}